export enum PhasrIcons {
  BEHAVIORAL_PROFILES_ICON = 'behavioral-profiles-icon'
}
